import React, { useEffect, useState } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {Container} from 'react-bootstrap'
import MenuAdmin from '../components/menus/MenuAdmin'
import Sidebar from '../components/menus/Sidebar'
import Dashboard from '../pages/admin/Dashboard'
import Users from '../pages/admin/Users'
import { useAuth } from '../components/auth/useAuth'
import NothingHere from '../pages/error/NothingHere'
import Animals from '../pages/admin/Animals'
import Protocols from '../pages/admin/Protocols'
import Farms from '../pages/admin/Farms'
import Lots from '../pages/admin/Lots'
import Templates from '../pages/admin/Templates'
import Zones from '../pages/admin/Zones'

export default function AdminRouter () {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const {clientauth} = useAuth()

	const [isCollapsed, setIsCollapsed] = useState(false)
	const toggleSidebar = () => {
		setIsCollapsed(!isCollapsed)
	}

    useEffect(() => {
		let token = localStorage.getItem('jwt')

		if (!token) {
			navigate(`/${t("url.auth.login")}`)
		}
    }, [navigate, t])

	const adminRoutesAlias = {
		"": "dashboard",
		[t("url.admin.dashboard")]: "dashboard",
		[t("url.admin.users")]: "users",
		[t("url.admin.animals")]: "animals",
		[t("url.admin.protocols")]: "protocols",
		[t("url.admin.farms")]: "farms",
		[t("url.admin.lots")]: "lots",
		[t("url.admin.templates")]: "templates",
		[t("url.admin.zones")]: "zones"
	}

	const getComponentAdmin = (path) => {
		switch (path) {
			case "dashboard": return <Dashboard/>;
			case "users": return <Users/>;
			case "animals": return <Animals/>;
			case "protocols": return <Protocols/>;
			case "farms": return <Farms/>;
			case "lots": return <Lots/>;
			case "templates": return <Templates/>;
			case "zones": return <Zones/>;
			default: return <NothingHere />;
		}
	}

	return (
		<Container fluid className='d-flex p-0'>
			<Sidebar rol={clientauth?.rol}/>
			<Container fluid className={`contenedor ${isCollapsed ? 'expanded' : ''}`}>
				<MenuAdmin toggleSidebar={toggleSidebar} isCollapsed={isCollapsed}/>
				<Routes>
					{Object.entries(adminRoutesAlias).map(([alias, path]) => (
						<Route key={alias} path={alias} element={getComponentAdmin(path)} />
					))}
					<Route path="*" element={<NothingHere />}/>
				</Routes>
			</Container>
		</Container>
	)
}